import { Loading, ShowContextProvider, ShowControllerProps, useShowController } from 'react-admin'
import { Card, Container, Stack, styled } from '@mui/material'
import { useRouteExtract } from '../../hooks/useRouteExtract'
import { useMemo } from 'react'
import config from '../../config'
import ModifyTimeStamp from '../../components/ModifyTimeStamp'
import { PromotionImgHeader } from '../../components/domains/promotion/PromotionImgHeader'
import { PromotionTitle } from '../../components/domains/promotion/PromotionTitle'
import { PromotionAuthor } from '../../components/domains/promotion/PromotionAuthor'
import { PromotionContent } from '../../components/domains/promotion/PromotionContent'
import PromotionImages from '../../components/domains/promotion/PromotionImages'

const StackStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4, 2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 10),
  },
}))

const CardPreview = styled(Card)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    borderRadius: 0,
    boxShadow: 'none',
  },
}))

const ContainerStyled = styled(Container)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    padding: 0,
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(12, 0),
  },
}))

const langSupports = config('langSupports')

export const PromotionPreview: React.FC = () => {
    const { pathSegments, queryParams } = useRouteExtract()
    const lang = queryParams['lang']
    const langActive = useMemo(() => (langSupports.includes(lang) ? lang : 'th'), [lang])
  const [resourceName, newId] = pathSegments
  const showProps: ShowControllerProps = {
    disableAuthentication: true,
    id: newId,
    resource: resourceName,
  }
  const showController = useShowController(showProps)
  const { isLoading } = showController

  if (isLoading) return <Loading />

  return (
    <ShowContextProvider value={showController}>
      <ContainerStyled maxWidth='md'>
        <CardPreview elevation={0}>
          <PromotionImgHeader source='thumbnail.full_path' />
          <StackStyled spacing={1}>
            <ModifyTimeStamp language={`${langActive}`} />
            <PromotionTitle source={`title_${langActive}`} />
            <PromotionAuthor authorSource='create_by' dateSource='create_at' />
            <PromotionContent source={`description_${langActive}`} />
            {/* <PromotionContent source={`short_description_${langActive}`} /> */}
            <PromotionImages source='images' title='name' />
          </StackStyled>
        </CardPreview>
      </ContainerStyled>
    </ShowContextProvider>
  )
}

export default PromotionPreview
